/**
 * Maps i18n language code to a BCP 47 locale for date formatting.
 * Use with toLocaleDateString/toLocaleString/Intl.DateTimeFormat.
 */
const LOCALE_MAP = {
  es: 'es-AR',
  en: 'en-US',
  pt: 'pt-BR',
};

export function getDateLocale(language) {
  return LOCALE_MAP[language] || language || 'es-AR';
}
